var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31234 0.92575L0.416504 3.19879V14.2304L4.31234 12.6246V0.92575ZM5.729 12.3958L6.96859 13.1275V10.8658C6.96843 10.0438 7.1802 9.23563 7.58345 8.51933C7.9867 7.80304 8.5678 7.20281 9.27067 6.77658V2.60733L5.729 0.515625V12.3958ZM14.5832 0.772042V7.01387C14.0297 6.6077 13.3955 6.32509 12.7234 6.18517C12.0512 6.04525 11.3569 6.05127 10.6873 6.20283V2.37783L14.5832 0.772042ZM11.7498 15.7894L11.606 15.6945C11.4757 15.6088 11.3454 15.5231 11.2186 15.431C10.741 15.0785 10.2986 14.6807 9.89755 14.2431C9.19275 13.4682 8.38525 12.2832 8.38525 10.8658C8.38525 10.4239 8.47228 9.98643 8.64137 9.57822C8.81045 9.17001 9.05829 8.7991 9.37072 8.48667C9.68315 8.17424 10.0541 7.92641 10.4623 7.75732C10.8705 7.58823 11.308 7.50121 11.7498 7.50121C12.1917 7.50121 12.6292 7.58823 13.0374 7.75732C13.4456 7.92641 13.8165 8.17424 14.129 8.48667C14.4414 8.7991 14.6892 9.17001 14.8583 9.57822C15.0274 9.98643 15.1144 10.4239 15.1144 10.8658C15.1144 12.2832 14.3069 13.4682 13.6021 14.2431C13.2011 14.6807 12.7587 15.0785 12.2811 15.431C12.1543 15.5231 12.024 15.6081 11.8936 15.6945L11.7498 15.7894ZM12.6353 10.3345H10.8644V11.7512H12.6353V10.3345Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.556923fbf20b8960fc30bd3b50a40765.svg";
export { ForwardRef as ReactComponent };